import { Col } from 'reactstrap'
import classes from './LoadingSpinner.module.css'

const LoadingSpinner = () => {
  return <Col className={classes.spinner}></Col>
}

export default LoadingSpinner
